/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable, zip } from 'rxjs';
import { AccessService } from 'src/app/providers/access/access.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';

@Component({
  selector: 'app-submission',
  templateUrl: './submission.page.html',
  styleUrls: ['./submission.page.scss'],
})
export class SubmissionPage implements OnInit {
  user: any;
  unreadCount: any;
  subRole: any;
  subtype: string;
  type = '0';
  when = '0';
  page = 1;
  perPage: number;
  hasSkelton: boolean;
  submissionList: any[] = [];
  total_subs:any;
  // eslint-disable-next-line @typescript-eslint/ban-types
  state$: Observable<object>;
  deleteIndex = null;
  constructor(
    private apiService: ApiService,
    public router: Router,
    public navCtrl: NavController,
    public toastService: ToastService,
    public route: ActivatedRoute,
    public events: EventsService,
    public accessService: AccessService,

  ) {
    this.perPage = 10;
    this.route.queryParams.subscribe((params) => {
      if (params && params.type) {
        this.type = params.type;
      }
    });
  }

  ngOnInit() {
    this.subtype="Received";
    this.getnotificationCount();
    this.submissionLists(this.type, this.when);
    this.events.subscribe('isPatientDeleted', (data: any) => {
      if (data && this.deleteIndex >= 0 && this.submissionList.length) {
        this.submissionList.splice(this.deleteIndex, 1);
      }
    });
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }

  segmentChanged(ev: any) {
    //console.log('Segment changed', this.type);
    this.submissionList = [];
    this.page = 1;
    this.submissionLists(this.type, this.when);
    if (this.type == "0")
    {
      this.subtype = "Received";
    }    
    if (this.type == "2")
    {
      this.subtype = "Downloaded by Medbill";
    }
    if (this.type == "3")
    {
      this.subtype = "Returned for Action";
    }

  }
  whensegmentChanged(ev: any) {
    this.submissionList = [];
    this.page = 1;
    this.submissionLists(this.type, this.when);

  }

  getnotificationCount() {
    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => { }
      );
  }

  submissionLists(status, when) {
    this.hasSkelton = true;
    const params = {
      page: this.page,
      perPage: this.perPage,
      status,
      when,
    };
    this.apiService.post('submission-list', params).subscribe(
      (res) => {
        //console.log('status: ',status, 'when: ',when, 'result: ',res);
        this.hasSkelton = false;
        if (res.error === false) {
          //console.log(when);
          //console.log('subs:',res.data);
          this.page++;
          this.total_subs = 20;
          this.submissionList = res.data.submissions;
        }
      },
      (err) => {
        //console.log('err',err);
        this.hasSkelton = false;
      }
    );
  }

  doInfinite(infiniteScroll) {
    this.hasSkelton = true;
    const params = {
      page: this.page,
      perPage: this.perPage,
      User: this.user,
      status: this.type,
      when: this.when
    };
    this.apiService.post('submission-list', params).subscribe(
      (res) => {
        //console.log('status: ',status, 'when: ',this.when, 'result: ',res);
        this.hasSkelton = false;
        if (res.error === false) {
          res.data.submissions.forEach((p) => {
            this.submissionList.push(p);
          });
          this.page++;
          infiniteScroll.target.complete();
        }
      },
      async (err) => {
        this.hasSkelton = false;
        infiniteScroll.target.complete();
      }
    );
  }

  submissionInfo(data, i) {
    this.deleteIndex = i;
    const navigationExtras: NavigationExtras = {
      state: data
    };
    this.navCtrl.navigateForward(['/submissionInfo'], navigationExtras);
  }


}
